import React, { useEffect, useState } from "react";
import ConfigurationPage from "templates/ConfigurationPage";
import EditLocation from "./EditLocation";
import DeleteModal from "../../../../../components/DeleteModal";
import { Button } from "rsuite";
import useRequestHandler from "hooks/useRequestHandler";

const locationTypes = {
    homeHealth: "Home Health",
    facility: "Facility"
}

const ViewLocation = (props) => {
    const { locationId, org, auth, history } = props;
    const [locationInfo, setLocationInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [editLocationModal, setEditLocationModal] = useState(false);
    const [deleteLocationModal, setDeleteLocationModal] = useState(false);
    const [blockButtons, setBlockButtons] = useState(false);

    const locationTypeKey = locationInfo?.isHomeCare ? "homeHealth" : "facility";
    const isAdminUser = props.auth.currentUser?.role?.includes("admin");

    const openEditModal = () => setEditLocationModal(true);
    const openDeleteModal = () => setDeleteLocationModal(true);

    const getLocationsRequest = useRequestHandler({
        auth,
        apiArguments: [org, locationId],
        apiName: "getFacility",
        successMessageData: { show: false },
        errorMessageData: {
            message: "Cannot load location data, please try again later",
        }
    });


    const getLocationInfo = async () => {
        setIsLoading(true);
        await getLocationsRequest(locationInfo => setLocationInfo(locationInfo));
        setIsLoading(false);
    }

    useEffect(() => getLocationInfo(), [])

    return (
        <>
            <EditLocation
                modalOpen={editLocationModal}
                setModalOpen={setEditLocationModal}
                auth={auth}
                formValues={locationInfo}
                getLocationInfo={getLocationInfo}
            />

            {isAdminUser && <DeleteModal
                    auth={props.auth}
                    modalOpen={deleteLocationModal}
                    setModalOpen={setDeleteLocationModal}
                    contentLoader={"Deleting location"}
                    apiName={"deleteFacility"}
                    apiArguments={{ orgId: auth.currentUser.defaultOrg, facilityId: locationId }}
                    successMessageData={`Location ${locationId} was successfully deleted.`}
                    errorMessageData={"You cannot delete location that associated with beds or patients"}
                    goBackUrl={"/configuration/locations"}
                    history={history}
                >
                    Are you sure you want to delete a {locationInfo?.id} ?
                </DeleteModal>}

            <ConfigurationPage.Content
                isLoading={isLoading}
                className="locations-edit"
                loaderSize="md"
            >
                <div className="locations-edit-start">
                    <div className="data">
                        <div className="field-title">Name</div>
                        <div className="field-value">{locationInfo?.id}</div>
                    </div>
                    <div className="data">
                        <div className="field-title">Time Zone</div>
                        <div className="field-value">{locationInfo?.timezone}</div>
                    </div>
                    <div className="data">
                        <div className="field-title">Type</div>
                        <div className="field-value">{locationTypes[locationTypeKey] ? locationTypes[locationTypeKey] : "-"}</div>
                    </div>
                </div>
                <div className="locations-edit-end">
                    <Button appearance="ghost" size="lg" color="cyan" disabled={blockButtons} className="plain-btn" onClick={openEditModal}>Edit</Button>
                    {isAdminUser && <Button appearance="primary" color="red" size="lg" loading={blockButtons} onClick={openDeleteModal}>Delete</Button>}
                </div>
            </ConfigurationPage.Content>
        </>
    );
};


ViewLocation.defaultProps = {
    locationId: null,
    org: null,
    auth: null,
    history: null
}

export default ViewLocation;